function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#48A23E",
  d: "M15 26.95L8.05 20 5.683 22.35 15 31.667 35 11.667 32.65 9.317z"
});
const SvgIcCheck = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-check.d6d793bb.svg";
export { ForwardRef as ReactComponent };